export default __webpack_public_path__ + "static/media/wave.293cf295.svg";